import { getMsalAccessToken } from "@ey/voltron-core";
import config from "@ey/voltron-config";

interface TokenParams {
  url: string;
  audience: string;
  scopes?: string[];
  loginHint?: string;
}

export const getAccessToken = async (params?: TokenParams): Promise<string | null> => {
  try {
    const accessToken = await getMsalAccessToken(config.ad, {
      url: params?.url,
      audience: params?.audience,
      scopes: params?.scopes,
      loginHint: params?.loginHint,
      handleInteractiveSignIn: false,
    });

    return accessToken;
  } catch (error) {
    console.error("Error getting access token:", error);
    return null;
  }
};
